import { render, staticRenderFns } from "./CustomerInfoItem.vue?vue&type=template&id=f9c11a16&"
import script from "./CustomerInfoItem.vue?vue&type=script&lang=js&"
export * from "./CustomerInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInfoItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports